import Vue from 'vue'
import VueRouter from 'vue-router'
import cookie from '../util/cookie.js'

const Home = () => import('../views/home/Home')
const Design = () => import('../views/design/design')
const Product = () => import('../views/product/product')
const Technology = () => import('../views/technology/technology')
const Gltf = () => import('../views/gltf/gltf')
const Solution = () => import('../views/Solution/Solution')
const upload = () => import('../views/upload/upload')
const login = () => import('../views/login/login')
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		component: Home,
		meta: {
			keepAlive: true, //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false
		}
	},
	{
		path: '/design',
		component: Design,
		meta: {
			keepAlive: true, //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false
		}
	},
	{
		path: '/product',
		name: 'product',
		component: Product,
		meta: {
			keepAlive: true , //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false	
		}
	},
	{
		path: '/technology',
		component: Technology,
		meta: {
			keepAlive: true , //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false
		}
	},
	{
		path: '/gltf',
		component: Gltf,
		meta: {
			keepAlive: true, //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false
		}
	},
	{
		path: '/Solution',
		component: Solution,
		meta: {
			keepAlive: true, //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : true,
			backHome : false
		}
	},
	{
		path: '/upload',
		name: 'upload',
		component: upload,
		meta: {
			title: '上传',
			keepAlive: false,
			needLogin: true, //导航栏在该页面不予显示
			isShowLogo : false,
			isShowLogin : false,
			backHome : false
			
		}
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			title: '登录',
			layout: 'login',
			needLogin: true,
			keepAlive: false , //导航栏在该页面不予显示
			isShowLogo : true,
			isShowLogin : false,
			backHome : true,
			showFooter: false
		}
	}
]

const router = new VueRouter({
	routes,
	mode: 'hash',
	base: process.env.BASE_URL,
})

export default router
